
riot.tag2('geotargeting-vars-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Изменить макропеременную</div>\n    </yield>\n    <yield to="body">\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label"> Значение</label>\n          <textarea class="form-control" name="value" value="{item.value}" style="min-height: 200px;"></textarea>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;
self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.mixin('change');
    modal.item = opts.item || {};
    self.update();
});
});


// WEBPACK FOOTER //
// ./pages/settings/geotargeting/geotargeting-vars-modal.tag